import React from "react";
import styles from "../Layout.module.css";
import gql from "graphql-tag";
import {useQuery} from "@apollo/react-hooks";

const SESSIONS = gql`
  {
    sessions {
      accountID
      email
      name
      roleARN
      roleName
      userID
      createdAt {
        date(format: "Mon Jan 2, 3:04:05pm")
        ago
      }
    }
  }
`

const AuditPage = (props) => {
  const {loading, error, data} = useQuery(SESSIONS);

  if (loading) {
    // intentionally left blank
  } else if (error) {
    return <div>{error}</div>
  }

  const sessions = [];
  if( data && data.sessions) {
    for (let i in data.sessions) {
      const session = data.sessions[i];
      sessions.push(<tr className={styles.tr}>
        <td>{session.name}</td>
        <td>{session.email}</td>
        <td>{session.accountID}</td>
        <td>{session.roleName}</td>
        <td>{session.createdAt.date}</td>
        <td>{session.createdAt.ago}</td>
      </tr>)
    }
  }

  return <div>
    <div className={styles.t2}/>
    <div className={styles.container}>
      <h2>Sessions</h2>
      <table>
        <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>AWS Account ID</th>
          <th>AWS Role Name</th>
          <th>Session Started</th>
          <th>Elapsed</th>
        </tr>
        </thead>
        <tbody>
        {sessions}
        </tbody>
      </table>
    </div>
  </div>;
}

export default AuditPage;
